import { useTranslation } from 'react-i18next';

export function RoadmapFallback() {
  const { t } = useTranslation();
  return (
    <div className="col ps-0 overflow-x-auto my-0 d-flex align-items-center justify-content-center">
      <p className="text-basic">{t('roadmap.error')}</p>
    </div>
  );
}
